'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;

var _controller = require('./controller');

var _controller2 = _interopRequireDefault(_controller);

var _modal = require('../ui/modal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var box = void 0;

function init() {
    box = document.querySelector('.js-postcode-lookup-content');
    (0, _controller2.default)('.js-postcode-lookup-content-form', onSuccess);
}

function onSuccess(_ref) {
    var data = _ref.data,
        formData = _ref.formData;

    if (data.success) {
        if (data.view) {
            swapOutIntroBox(data.view);
            requestAnimationFrame(function () {
                callOtherPostcodeLookup(formData);
            });
        } else {
            _modal.modalController.openModal('ThankYou');
        }
        this.resetForm();
        return;
    }

    if (data.msg) {
        this.errorMessageEl.innerHTML = '<p>' + data.msg + '</p>';
        this.errorMessageEl.classList.add('active');
    }

    if (data.modal) {
        setupModal(data.modal);
    }
}

function callOtherPostcodeLookup(formData) {
    var form = document.querySelector('.js-postcode-lookup');

    if (!form) {
        return;
    }

    form.querySelector('[name=postcode]').value = formData.postcode;
    form.querySelector('button').click();
}

function setupModal(html) {
    _modal.modalController.addModal('postcodeLookupModal', html);
    _modal.modalController.openModal('postcodeLookupModal');

    var modal = document.querySelector('[data-modal-item-id=postcodeLookupModal]');

    if (!modal) {
        return;
    }

    var form = modal.querySelector('form');
    (0, _controller2.default)(form, onModalSuccess);
}

function onModalSuccess(data) {
    if (data.success) {
        _modal.modalController.closeModal('postcodeLookupModal');

        if (data.view) {
            swapOutIntroBox(data.view);
        }
        return;
    }

    if (data.msg) {
        this.errorMessageEl.innerHTML = '<p>' + data.msg + '</p>';
        this.errorMessageEl.classList.add('active');
    }
}

function swapOutIntroBox(viewHtml) {
    var newHTML = void 0;
    var div = document.createElement('div');
    div.innerHTML = viewHtml;
    if (div.firstElementChild) {
        newHTML = div.firstElementChild;
    }

    if (newHTML) {
        box.firstElementChild.remove();
        box.appendChild(newHTML);
        box.style.opacity = 0;
        box.style.transform = 'translateY(30px)';

        requestAnimationFrame(function () {
            box.style.transition = 'opacity 850ms cubic-bezier(0.3, 0.15, 0.18, 1), transform 850ms cubic-bezier(0.3, 0.15, 0.18, 1)';

            requestAnimationFrame(function () {
                box.style.opacity = 1;
                box.style.transform = 'none';
            });
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/form/postcode-lookup-content.js
// module id = ./resources/assets/js/src/form/postcode-lookup-content.js
// module chunks = 0